import React from "react";

// Global on/off switch primitive — click-triggered state animation only
// (no hover motion), safe under the project's "no hover animation" rule.
//
// Usage:
//   <Toggle checked={value} onChange={setValue} />
//   <Toggle checked={value} onChange={setValue} size="sm" disabled />
const SIZES = {
  sm: { track: "w-8 h-[18px]", thumb: "w-3.5 h-3.5", on: "translate-x-[15px]", off: "translate-x-[2px]" },
  md: { track: "w-10 h-[22px]", thumb: "w-[18px] h-[18px]", on: "translate-x-[19px]", off: "translate-x-[2px]" },
};

export default function Toggle({ checked, onChange, disabled = false, size = "md" }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!checked)}
      className={`relative inline-flex shrink-0 items-center rounded-full transition-colors duration-150 ${s.track} ${
        checked ? "bg-primary" : "bg-surface_alt border border-border"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span
        className={`pointer-events-none inline-block rounded-full bg-white shadow transition-transform duration-150 ${s.thumb} ${
          checked ? s.on : s.off
        }`}
      />
    </button>
  );
}
